import { render, staticRenderFns } from "./BGrupoDadosCampoForm.vue?vue&type=template&id=5aad42ff"
import script from "./BGrupoDadosCampoForm.vue?vue&type=script&lang=js"
export * from "./BGrupoDadosCampoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports